import React, {useState} from 'react';

import {Accordion, Alert, Button, Col, Form, Modal, Row, Spinner, Table} from 'react-bootstrap';
import {calcApiFetch, citiesFetch, pvzFetch} from '../fetch/fetch';
import {isMobile} from 'react-device-detect';

import {nearlyWeight, priceCalc} from './price';
import ItemSelector from './ItemSelector';
import fetchJsonp from 'fetch-jsonp';
import {InputCustomString} from "./InputCustom";


const calcCities = (query, okCallback, errCallback) => {
    const url = 'https://api.cdek.ru/city/getListByTerm/jsonp.php?q=' + query;
    fetchJsonp(url).then(function (response) {
        return response.json()
    }).then(function (json) {
        okCallback(json.geonames ? json.geonames : []);
    }).catch(function (ex) {
        console.log('parsing failed', ex)
    });
};

const calcDeliveryPrice = (weight, width, length, height, to_post_code, cost, okCallback, errorCallback) => {
    const json = {
        goods: [{
            weight: weight / 1000.,
            width: width,
            length: length,
            height: height,
        }],
        version: "1.0",
        senderCityId: 270,
        receiverCityPostCode3: to_post_code,
        tariffId: 137
    };

    const url = 'http://api.edostavka.ru/calculator/calculate_price_by_jsonp.php?json=' + JSON.stringify(json);
    fetchJsonp(url).then(function (response) {
        return response.json()
    }).then(function (json) {
        okCallback(json);
    }).catch(function (ex) {
        errorCallback(ex);
    });
};

const createOrder = (items, user, onOrderSuccess, onOrderError) => {
    if (!items || items.length === 0) {
        return;
    }
    const data = {action: 'add_order', items: JSON.stringify(items), user: JSON.stringify(user)};

    let fd = new FormData();

    items.forEach((item, index) => {
        if (item.file) {
            fd.append('file_' + index, item.file);
        }
    });

    Object.keys(data).forEach(key => {
        fd.append(key, data[key]);
    });

    const params = {
        method: 'POST',
        body: fd
    };
    calcApiFetch('/wp-admin/admin-ajax.php?action=add_order',
        params,
        result => onOrderSuccess(result.status, result.uuid),
        (e) => onOrderError(e)
    );
};


const DeliveryType = ({item, onChange, options, items, onFieldChange, onCityChange, cities, pvz}) => {
    const [punkt, setPunkt] = React.useState(null);

    const buttons = [];
    if (item.city && item.city.includes('овосибирск')) {
        buttons.push({label: 'Самовывоз (Новосибирск)', value: 'own'})
        buttons.push({label: 'До офиса (Новосибирск)', value: 'office'});
    }

    return <>
        <h4>Доставка</h4>

        {(item.delivery === 'cdek' || item.delivery === 'own' || item.delivery === 'office') &&
        <Row>
            <Col xs={12} sm={6} md={6}>
                <Form.Group controlId='city'>
                    <Form.Label>Выберите Ваш регион (РФ)</Form.Label>
                    <Form.Control size='lg'
                                  as='select'
                                  custom
                                  name='city'
                                  required={true}
                                  isInvalid={!item.city}
                                  onChange={(e) => {
                                      setPunkt(null);
                                      onCityChange(e);
                                  }}>
                        <option key={-1} value={null}></option>
                        {cities.map((city, key) =>
                            (<option key={key}
                                     value={city.code}
                                     selected={item.city === `${city.name}`}>{city.name}</option>)
                        )}
                    </Form.Control>
                </Form.Group>
            </Col>
            <Col xs={12} sm={6} md={6}>
                {item.city && <Form.Group controlId='street'>
                    <Form.Label>Пункты выдачи посылок СДЭК в Вашем регионе</Form.Label>
                    <Form.Control size='lg'
                                  as='select'
                                  name='street'
                                  required={true}
                                  isInvalid={!item.street}
                                  onChange={e => {
                                      const {value} = e.currentTarget;
                                      const p = pvz.find(el => el.FullAddress === value);
                                      setPunkt(p);
                                      onChange({...item, ...{delivery: 'cdek', city: item.city, street: value}});
                                  }}>
                        <option key={-1} value={null}></option>
                        {pvz.map((c, key) =>
                            (<option key={key} value={c.FullAddress}
                                     selected={c.FullAddress === item.street}>{c.FullAddress}</option>)
                        )}
                        <optgroup label=""></optgroup>
                    </Form.Control>
                    Вы можете посмотреть ближайшие к Вам пункты выдачи на карте компании <a target="_blank"
                                                                                            href="https://cdek.ru/offices">СДЭК</a>

                </Form.Group>}
            </Col>
            <Col xs={12}>
                <p>Осуществляем отгрузку в любую точку России транспортной компанией <strong>СДЭК</strong>.<br/>
                    {buttons.length === 0 && <>В настоящий момент стоимость доставки посылки в любой город до офиса СДЭК
                        составляет 490 рублей, </>}
                    {buttons.length > 0 && <>Стоимость доставки компанией СДЭК по Новосибирску и Новосибирской области
                        составляет 300 рублей, </>}
                    оплата доставки производится при получении отправления.</p>
            </Col>
            {punkt && <Col xs={12}>
                <center>
                    <h5>{item.street}</h5>
                    <img style={{marginTop: 20}} width="600"
                         height="300"
                         src={`https://static-maps.yandex.ru/1.x/?ll=${punkt.coordX},${punkt.coordY}&size=600,300&z=16&l=map&pt=${punkt.coordX},${punkt.coordY}`}>
                    </img></center>
            </Col>}
            {buttons.length > 0 &&
            <Col xs={12}>
                <ItemSelector
                    item={item}
                    values={buttons}
                    name='delivery'
                    title=''
                    onChange={(item) => onChange({...item, ...{street: '', price: ''}})}>
                </ItemSelector>
            </Col>}
        </Row>}

        {item.delivery === 'other' &&
        <Row>
            <Col xs={12}>
                <strong>Вы можете выбрать доставку Почтой России, если в Вашем населенном пункте нет офиса
                    СДЭК.</strong><br/>
                Напишите, пожалуйста, Ваш точный почтовый адрес для отправки Вашего заказа Почтой России.
                <br/>
                <strong>Услуги доставки Почтой России оплачиваются вместе со стоимостью заказа</strong>.
                <br/>
            </Col>
            <Col xs={12} sm={3}>
                <InputCustomString name={'index'}
                                   label={'Индекс'}
                                   value={item.index}
                                   onChange={index => onChange({...item, index})}/>
            </Col>
            <Col xs={12} sm={4}>
                <InputCustomString name={'city'}
                                   label={'Город'}
                                   value={item.city}
                                   onChange={city => onChange({...item, city})}/>
            </Col>
            <Col xs={12} sm={5}>
                <InputCustomString name={'street'}
                                   label={'Адрес'}
                                   value={item.street}
                                   onChange={street => onChange({...item, street})}/>
            </Col>
            <Col xs={12}>
                <center><br/><br/>
                    <Button size={'lg'}
                            variant='danger'
                            onClick={() => onChange({
                                ...item, ...{
                                    delivery: 'cdek',
                                    city: '',
                                    street: '',
                                    price: ''
                                }
                            })}>Выбрать пункт СДЭК</Button>
                </center>
            </Col>
        </Row>}
        {item.delivery === 'own' &&
        <Row>
            <Col xs={12}>
                <p>
                    Самовывоз: {options.address1}<br/>
                    <br/> Если возникли вопросы, позвоните по номеру {options.phone}
                </p>
            </Col>
        </Row>

        }
        {item.delivery === 'office' && <><p>
            Бесплатная доставка — при заказе на сумму более 7000 рублей. При заказе на меньшую сумму
            стоимость
            доставки составляет 300 рублей. Срочная доставка — 500 рублей.
            <br/> Если возникли вопросы, позвоните по номеру {options.phone}
        </p>
            <Row>
                <Col xs={12}>Напишите, пожалуйста, Ваш адрес. </Col>
                <Col xs={12} sm={6}>
                    <InputCustomString name={'city'}
                                       label={'Город'}
                                       disabled={true}
                                       value={'Новосибирск'}
                                       onChange={city => onChange({...item, city})}/>
                </Col>
                <Col xs={12} sm={6}>
                    <InputCustomString name={'street'}
                                       label={'Адрес'}
                                       value={item.street}
                                       onChange={street => onChange({...item, street})}/>
                </Col>
            </Row>
        </>}
        {!item.street && item.delivery !== 'other' && <Row><Col xs={12}>
            <center><br/><br/>
                <Button size={'lg'}
                        variant='danger'
                        onClick={() => onChange({
                            ...item, ...{
                                delivery: 'other',
                                city: '',
                                street: '',
                                price: ''
                            }
                        })}>У Вас в населенном пункте нет офиса СДЭК?</Button>
            </center>
        </Col></Row>}
    </>
};

const PaymentType = ({item, onChange, onFieldChange}) => {
    const buttons = [
        {label: 'Нужен счет на оплату', value: 'order'},
        {label: 'Хочу оплатить онлайн', value: 'online'},
    ];
    return (
        <>
            <ItemSelector
                item={item}
                values={buttons}
                name='payment'
                title='Как хотите оплатить'
                onChange={onChange}/>
        </>);
};

const OrderRow = ({item, options, index, deleteItem}) => (
    <tr>
        <td>{index}</td>
        <td>
            <OrderRowMobile
                deleteItem={deleteItem}
                item={item}
                options={options}
                index={index + 1}
                key={index}/>
        </td>
        <td>
            {priceCalc(item, options)} ₽
        </td>
        {/*        <td>
            <Button variant='danger' onClick={() => deleteItem(index)}>x</Button>
        </td>*/}
    </tr>
);

const OrderRowMobile = ({item, options, index, deleteItem}) => (
    <ul style={{listStyle: 'none', textAlign: 'left'}}>
        <li>Форма:&#160;
            {item.shape === 'square' && 'Квадрат'}
            {item.shape === 'rectangle' && 'Прямоугольник'}
            {item.shape === 'circle' && 'Круг'}
            {item.shape === 'oval' && 'Овал'}
        </li>
        <li>Размеры: {item.width}x{item.height} мм</li>
        {/*
        <li>Расстояние между этикетками в рулоне: {item.distance} мм</li>
*/}
        {(item.shape === 'square' || item.shape === 'rectangle') &&
        <li>Угол:&#160;
            {(item.shape === 'square' || item.shape === 'rectangle') && item.corner === '90' && 'Прямой'}
            {(item.shape === 'square' || item.shape === 'rectangle') && item.corner === 'rounded' && 'Скругленный '}
            {(item.shape === 'square' || item.shape === 'rectangle') && item.corner === 'rounded' && (item.radius + ' мм')}
        </li>
        }
        <li>Бумага:&#160;
            {item.paper === 'semi_glossy_photo_paper_2' && 'Полуглянцевая бумага'}
            {item.paper === 'glossy_photo_paper' && 'Полуглянцевая бумага'}

            {item.paper === 'matte_paper' && 'Полуматовая бумага'}
            {item.paper === 'matte_paper_2' && 'Полуматовая бумага'}

            {item.paper === 'glossy_film' && 'Белая плёнка'}
            {item.paper === 'white_film_2' && 'Белая плёнка'}

            {item.paper === 'transparencies' && 'Прозрачная плёнка'}
            {item.paper === 'transparencies_2' && 'Прозрачная плёнка'}

            {item.paper === 'silver_film' && 'Серебряная плёнка'}
            {item.paper === 'silver_film_2' && 'Серебряная плёнка'}

            {item.paper === 'gold_film' && 'Золотая плёнка'}
            {item.paper === 'gold_film_2' && 'Золотая плёнка'}
        </li>
        <li>Ламинация:&#160;
            {item.laminate === 'glance_laminate' && 'Глянцевая'}
            {item.laminate === 'mate_laminate' && 'Матовая'}
            {item.laminate === 'no' && 'Нет'}</li>
        <li>Упаковка: {item.sleeve}</li>
        <li>Направление этикеток в рулоне:&#160;
            {item.direction === 'important' ? ' важно' : ' не важно'}</li>
        <li>Кол-во: {item.counts} штук</li>
        <li>Цвет: {item.color}</li>
        <li>Примерный вес: {nearlyWeight(item, options)}г</li>
        <li>Стоимость: {priceCalc(item, options)} ₽</li>
        <li>
            <Button variant='danger' onClick={() => deleteItem(index - 1)}>x</Button>
        </li>
    </ul>
);

const createMarkup = (name) => {
    return {__html: name};
};

const OrderParams = ({items, options, weight, cost, onOrderSuccess}) => {
    const [show, setShow] = useState(false);
    const [spinner, setSpinner] = useState(false);

    const [cities, setCities] = React.useState([]);
    React.useEffect(() => {
        citiesFetch(setCities, console.log);
    }, []);

    const [pvz, setPvz] = React.useState([]);

    const [errField, setErrField] = useState('');
    const fioRef = React.useRef(null);
    const emailRef = React.useRef(null);
    const phoneRef = React.useRef(null);

    const [user, setUser] = React.useState({delivery: 'cdek', payment: 'online'});
    const onFieldChange = e => {
        const {name, value} = e.currentTarget;
        setUser({...user, ...{[name]: value}});
    };

    const onCityChange = e => {
        const {value} = e.currentTarget;
        if (value) {
            const city = cities.find(c => c.code == value);
            setUser({...user, ...{city: `${city.name}`, street: ''}});
            pvzFetch(city.code, e => {
                setPvz(e.sort((e1, e2) => e1.FullAddress.localeCompare(e2.FullAddress)))
            }, console.log);
        } else {
            setUser({...user, ...{city: '', street: '', price: ''}});
            setPvz([]);
        }
    };

    const onIndexChange = e => {
        const {value} = e.currentTarget;
        onFieldChange(e);
        if (value.length > 4)
            calcDeliveryPrice(weight, '10', '10', '10', value, cost, console.log, console.log);
    };

    if (!items.length) {
        return (<></>);
    }

    const cdek = user.delivery === 'cdek';
    const own = user.delivery === 'own';

    const makeOrder = () => {
        if (!user.fio) {
            setErrField('Имя Фамилия');
            fioRef.current.focus();
            setShow(true);
            return;
        }
        if (!user.email || !user.email.includes('@')) {
            setErrField('Email');
            emailRef.current.focus();
            setShow(true);
            return;
        }
        if (!user.phone) {
            setErrField('Телефон');
            phoneRef.current.focus();
            setShow(true);
            return;
        }
        if (cdek) {
            if (!user.city) {
                return;
            }
            if (!user.street) {
                return;
            }
        }

        setSpinner(true);
        createOrder(items, user, onOrderSuccess, (e) => {
            setSpinner(false);
            console.log(e);
            alert('Произошла ошибка про добавлении заказа, пожалуйста проверьте параметры заказа')
        });
    };

    return (
        <>
            <Form>
                <h4>Оформление заказа</h4>
                <p>Заполняя форму, Вы даёте согласие на
                    обработку персональных данных в соответствии с Федеральным законом “О
                    персональных данных” от 27.07.2006 №152-ФЗ и принимаете условия <a target='_blank'
                                                                                       href='/politics/'>Политики
                        конфиденциальности</a></p>
                <Row>
                    <Col xs={12} sm={6} md={4}>
                        <Form.Group controlId='fio'>
                            <Form.Label>Ваше Имя Фамилия</Form.Label>
                            <Form.Control size='lg'
                                          type='text'
                                          name='fio'
                                          isInvalid={!user.fio}
                                          required
                                          value={user.fio}
                                          ref={fioRef}
                                          onChange={onFieldChange}/>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                        <Form.Group controlId='email_'>
                            <Form.Label>Email</Form.Label>
                            <Form.Control size='lg'
                                          type='text'
                                          name='email'
                                          isInvalid={!user.email}
                                          required
                                          value={user.email}
                                          ref={emailRef}
                                          onChange={onFieldChange}/>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                        <Form.Group controlId='phone'>
                            <Form.Label>Телефон для связи</Form.Label>
                            <Form.Control size='lg'
                                          type='text'
                                          name='phone'
                                          isInvalid={!user.phone}
                                          required
                                          value={user.phone}
                                          ref={phoneRef}
                                          onChange={onFieldChange}/>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                        <Form.Group controlId='org'>
                            <Form.Label>Организация</Form.Label>
                            <Form.Control size='lg'
                                          type='text'
                                          name='org'
                                          value={user.org}
                                          onChange={onFieldChange}/>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                        <Form.Group controlId='address'>
                            <Form.Label>Юридический адрес</Form.Label>
                            <Form.Control size='lg'
                                          type='text'
                                          name='address'
                                          value={user.address}
                                          onChange={onFieldChange}/>
                        </Form.Group>
                    </Col>
                    <Col xs={12} sm={6} md={4}>
                        <Form.Group controlId='inn'>
                            <Form.Label>ИНН</Form.Label>
                            <Form.Control size='lg'
                                          type='text'
                                          name='inn'
                                          value={user.inn}
                                          onChange={onFieldChange}/>
                        </Form.Group>
                    </Col>
                </Row>

                <PaymentType item={user} onChange={setUser} onFieldChange={onFieldChange}/>

                <DeliveryType item={user}
                              items={items}
                              options={options}
                              onChange={setUser}
                              cities={cities}
                              pvz={pvz}
                              onCityChange={onCityChange}
                              onFieldChange={onFieldChange}/>

                <Form.Group controlId='description'>
                    <Form.Label>Примечания</Form.Label>
                    <Form.Control size='lg'
                                  as='textarea'
                                  name='description'
                                  required
                                  value={user.description}
                                  onChange={onFieldChange}/>
                </Form.Group>
                <center>
                    <Button size='lg' variant='danger' onClick={makeOrder} disabled={spinner}>
                        Все верно, заказать
                    </Button>
                    <div>
                        {spinner && <>
                            <Spinner animation="border"/> <strong>Ваш заказ загружается</strong>
                            <h4>При возникновении сложностей по заполнению формы заказа позвоните нам по
                                телефону {options.phone}</h4>
                        </>}
                    </div>
                </center>
                <Modal show={show} onHide={() => setShow(false)} style={{top: '30%'}}>
                    <Modal.Body><h6>Укажите пожалуйста {errField}</h6></Modal.Body>
                    <Modal.Footer>
                        <Button variant='secondary' onClick={() => setShow(false)}>
                            Хорошо
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Form>
        </>
    );
};

const Order = ({items, options, deleteItem, onOrderSuccess, onGotoStart}) => {
    const reducer = (acc, cv) => acc + priceCalc(cv, options);
    const reducerWeight = (acc, cv) => acc + nearlyWeight(cv, options);
    const total = items.length > 0 ? items.reduce(reducer, 0) : 0;
    const totalWeight = items.length > 0 ? items.reduce(reducerWeight, 0) : 0;

    return (
        <>
            {items.length > 0 &&
            <Alert variant='primary'>
                <p>Вы можете добавить в Ваш заказ ещё этикетки другого дизайна. Просто <a href="#"
                                                                                          onClick={onGotoStart}>вернитесь
                    в начало</a> и
                    внесите новые параметры.<br/><br/><br/>
                    <center style={{fontWeight: 'bold'}}>Оригинал-макет этикетки присылайте ответом на письмо, полученное после
                        оформления заказа.</center>.
                </p></Alert>
            }

            <h3>Ваш заказ</h3>

            {!isMobile && <Table striped bordered hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Параметры</th>
                    <th>Стоимость</th>
                </tr>
                </thead>
                <tbody>
                {items.map((item, index) => {
                    return <OrderRow
                        deleteItem={deleteItem}
                        item={item}
                        options={options}
                        index={index + 1}
                        key={index}/>
                })}
                <tr>
                    <td colSpan={2}>Итого цена (включает НДС 20%)
                        {total > 15000 &&
                        <strong>
                            Если у Вас возникли вопросы, позвоните нам по телефону <nobr>{options.phone}</nobr><br/> или
                            напишите на электронную почту {options.email}
                        </strong>
                        }
                    </td>
                    <td>{total}&#160;₽ (*)</td>
                </tr>
                <tr>
                    <td colSpan={2}>Итого примерный вес</td>
                    <td>{totalWeight}&#160;г</td>
                </tr>
                </tbody>
            </Table>}

            {isMobile && <div>{items.map((item, index) => {
                return <OrderRowMobile
                    deleteItem={deleteItem}
                    item={item}
                    options={options}
                    index={index + 1}
                    key={index}/>
            })}</div>}

            {items.length > 0 && <Accordion>
                <Accordion.Toggle as={Button}
                                  variant="link"
                                  eventKey="0">
                    Посмотреть все условия *
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                    <ul style={{textAlign: 'left'}}>
                        <li>
                            Проверьте «Ваш заказ». Удалите всё лишнее и неверное с помощью красной
                            кнопки с крестиком. При необходимости вернитесь в начало и внесите новые
                            параметры.
                        </li>
                        <li><a target="_blank" href="/make-an-order/maket-requirements/">Требования к макету
                            самоклеящейся этикетки</a>.
                            <br/>Если у Вас нет готового оригинал-
                            макета, Вы можете заказать дизайн наклеек или этикеток у нас. Стоимость услуг
                            дизайнера обговаривается и оплачивается отдельно, в зависимости от сложности
                            макета и затрат времени.
                        </li>
                        <li>Стоимость рассчитана исходя из среднего расхода материалов на печать и
                            времени на высечение этикетки и не является публичной оффертой.
                        </li>
                        <li>Выставляет счет и рассчитывает точную стоимость заказа менеджер.</li>
                    </ul>
                </Accordion.Collapse>
            </Accordion>}

            {<OrderParams
                onOrderSuccess={onOrderSuccess}
                options={options}
                weight={totalWeight}
                cost={total}
                items={items}/>}
        </>);
};

export default Order;
